import { canonicalAutoAppyUrl } from './autoAppyUrls';
export function autoAppyAppInitials(name = '') {
  return name
    .split(/\s+/)
    .filter(Boolean)
    .map((part) => part[0])
    .join('')
    .slice(0, 2)
    .toUpperCase() || 'AA';
}

const internalApplicationNames = new Set(['auto appy sso', 'autoappy sso']);

export function autoAppySwitcherApps(apps = []) {
  if (!Array.isArray(apps)) return [];

  return apps.filter((app) => {
    if (!app || app.visible_in_switcher === false) return false;

    const applicationType = String(app.type || app.purpose || app.visibility || '').toLowerCase();
    if (['developer', 'internal'].includes(applicationType)) return false;

    return !internalApplicationNames.has(String(app.name || '').trim().toLowerCase());
  });
}

export function autoAppyAppLaunchUrl(app, workspaceId) {
  try {
    const main = app.key === 'main';
    const url = new URL(main ? canonicalAutoAppyUrl(app.frontend_url) : app.frontend_url);
    // The main app opens on Home and reads the organisation from ?organisation=.
    if (main && url.pathname === '/') url.pathname = '/home';
    if (workspaceId) url.searchParams.set(main ? 'organisation' : 'workspace', workspaceId);
    return url.toString();
  } catch {
    return app?.frontend_url || '#';
  }
}
